var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"max-width":"70%","padding":"200px 50px"},attrs:{"src":require('@/assets/401.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }